import React from 'react';

import { QUICKBOOKS_BASE_URL } from '../../../api';
import { TYPE_TITLE } from '../../../const/treatment';
import { mapDefaultRemoteOptions, mapPayeeOptions } from '../../../Helper';
import { RemoteOptionsResponse } from '../../../types';
import { FormTypeOption, FormTypeOptionComponentProps } from '../../../types/treatment';
import Form from '../Form/Form';

const SAVE_TREATMENT_ENDPOINT = `${QUICKBOOKS_BASE_URL}/:documentId/createBill`;

const mapRemoteOptions = (responseData: RemoteOptionsResponse) => {
  const payees = mapPayeeOptions(responseData.vendors, {});
  const defaultRemoteOptions = mapDefaultRemoteOptions(responseData);

  return {
    ...defaultRemoteOptions,
    payees,
  };
};

export const DISABLED_FIELDS = {
  isMethodDisabled: true,
  isAccountDisabled: true,
  isTermsDisabled: false,
  isDueOnDisabled: false,
};

const REQUIRED_FIELDS = {
  isMethodRequired: false,
  isAccountRequired: false,
  isTermsRequired: false,
  isDueOnRequired: true,
};

const UnpaidBillForm = ({ register, control, dropdowns }: FormTypeOptionComponentProps) => {
  return (
    <Form
      register={register}
      control={control}
      dropdowns={dropdowns}
      disabledFields={DISABLED_FIELDS}
      requiredFields={REQUIRED_FIELDS}
    />
  );
};

export default UnpaidBillForm;

export const title = TYPE_TITLE['Bill'];
const optionName = TYPE_TITLE['Bill'];
const id = 'Bill';

export const UnpaidBillFormOption: FormTypeOption = {
  id,
  title,
  optionName,
  Component: UnpaidBillForm,
  mapRemoteOptions,
  saveTreatmentEndpoint: SAVE_TREATMENT_ENDPOINT,
  disabledFields: DISABLED_FIELDS,
  requiredFields: REQUIRED_FIELDS,
};
